
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../locales/en/common.json';
import enNavigation from '../locales/en/navigation.json';
import enAuth from '../locales/en/auth.json';
import enAbout from '../locales/en/about.json';
import enFooter from '../locales/en/footer.json';
import enHomepage from '../locales/en/homepage.json';
import enHome from '../locales/en/home.json';
import enFilters from '../locales/en/filters.json';
import enPractitioners from '../locales/en/practitioners.json';
import enBooking from '../locales/en/booking.json';
import enClientAuth from '../locales/en/client-auth.json';
import enPractitionerAuth from '../locales/en/practitioner-auth.json';
import enDashboard from '../locales/en/dashboard.json';
import enFinances from '../locales/en/finances.json';
import enSettings from '../locales/en/settings.json';
import enCertifications from '../locales/en/certifications.json';
import enRecording from '../locales/en/recording.json';
import enCareers from '../locales/en/careers.json';
import enAdmin from '../locales/en/admin.json';
import enServiceSelection from '../locales/en/service-selection.json';

import zhCommon from '../locales/zh/common.json';
import zhNavigation from '../locales/zh/navigation.json';
import zhAuth from '../locales/zh/auth.json';
import zhAbout from '../locales/zh/about.json';
import zhFooter from '../locales/zh/footer.json';
import zhHomepage from '../locales/zh/homepage.json';
import zhHome from '../locales/zh/home.json';
import zhFilters from '../locales/zh/filters.json';
import zhPractitioners from '../locales/zh/practitioners.json';
import zhBooking from '../locales/zh/booking.json';
import zhClientAuth from '../locales/zh/client-auth.json';
import zhPractitionerAuth from '../locales/zh/practitioner-auth.json';
import zhDashboard from '../locales/zh/dashboard.json';
import zhFinances from '../locales/zh/finances.json';
import zhSettings from '../locales/zh/settings.json';
import zhCertifications from '../locales/zh/certifications.json';
import zhRecording from '../locales/zh/recording.json';
import zhCareers from '../locales/zh/careers.json';
import zhAdmin from '../locales/zh/admin.json';
import zhServiceSelection from '../locales/zh/service-selection.json';

import enCrisis from '../locales/en/crisis.json';
import zhCrisis from '../locales/zh/crisis.json';
import enServiceForm from '../locales/en/service-form.json';
import zhServiceForm from '../locales/zh/service-form.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    about: enAbout,
    footer: enFooter,
    homepage: enHomepage,
    home: enHome,
    filters: enFilters,
    practitioners: enPractitioners,
    booking: enBooking,
    'client-auth': enClientAuth,
    'practitioner-auth': enPractitionerAuth,
    dashboard: enDashboard,
    finances: enFinances,
    settings: enSettings,
    certifications: enCertifications,
    recording: enRecording,
    careers: enCareers,
    admin: enAdmin,
    crisis: enCrisis,
    'service-selection': enServiceSelection,
    'service-form': enServiceForm,
  },
  zh: {
    common: zhCommon,
    navigation: zhNavigation,
    auth: zhAuth,
    about: zhAbout,
    footer: zhFooter,
    homepage: zhHomepage,
    home: zhHome,
    filters: zhFilters,
    practitioners: zhPractitioners,
    booking: zhBooking,
    'client-auth': zhClientAuth,
    'practitioner-auth': zhPractitionerAuth,
    dashboard: zhDashboard,
    finances: zhFinances,
    settings: zhSettings,
    certifications: zhCertifications,
    recording: zhRecording,
    careers: zhCareers,
    admin: zhAdmin,
    crisis: zhCrisis,
    'service-selection': zhServiceSelection,
    'service-form': zhServiceForm,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'auth', 'about', 'footer', 'homepage', 'home', 'filters', 'practitioners', 'booking', 'client-auth', 'practitioner-auth', 'dashboard', 'finances', 'settings', 'certifications', 'recording', 'careers', 'admin', 'crisis', 'service-selection', 'service-form'],
    
    lng: 'en', // Force default to English
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      // Disable React strict mode dependencies to avoid hook issues
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

export default i18n;
